export default __webpack_public_path__ + "static/media/sohil.d1b91f66.jpg";